/* lb-theone-buybox – Logik (ausgelagert aus sections/lb-theone-buybox.liquid).
 * Initialisiert jede Buybox-Instanz anhand von <script type="application/json" data-lbgs-config>.
 */
(function(){
  if(window.__lbgsBooted) return;
  window.__lbgsBooted = true;

function lbgsInit(cfg){
  var SID  = String(cfg.sid);
  var VKEY = '__lbGS_' + SID.replace(/[\-\.]/g,'_');
  var vd   = window[VKEY] || [];


  var wrap     = document.getElementById('lbgs-' + SID);
  var sliderEl = document.getElementById('lbgs-sl-' + SID);
  var thumbsEl = document.getElementById('lbgs-th-' + SID);
  var atcBtn   = document.getElementById('lbgs-atc-' + SID);
  var vidInput = document.getElementById('lbgs-vid-' + SID);
  var priceEl  = document.getElementById('lbgs-price-' + SID);
  var cmpEl    = document.getElementById('lbgs-cmp-' + SID);
  var badgeEl  = document.getElementById('lbgs-badge-' + SID);
  var unitEl   = document.getElementById('lbgs-unit-' + SID);
  var qtyInput = document.getElementById('lbgs-qty-' + SID);
  var priceWrap= priceEl ? priceEl.closest('.lbgs__price-wrap') : null;
  if(!wrap) return;
  wrap.style.visibility='visible';


  /* ── Badges in ihre Container verschieben (Bild oben-links / Buybox oben-rechts) ── */
  (function(){
    var imgWrap = document.getElementById('lbgs-badges-img-' + SID);
    var boxWrap = document.getElementById('lbgs-badges-box-' + SID);
    wrap.querySelectorAll('.lbgs__badge').forEach(function(b){
      var pos = b.getAttribute('data-pos');
      if(pos === 'buybox' && boxWrap){ boxWrap.appendChild(b); }
      else if(imgWrap){ imgWrap.appendChild(b); }
    });
  })();


  var showBadge = priceWrap ? priceWrap.getAttribute('data-show-badge') === 'true' : false;
  var badgeType = priceWrap ? (priceWrap.getAttribute('data-badge-type') || 'percent') : 'percent';
  var badgePrefix = priceWrap ? (priceWrap.getAttribute('data-badge-prefix') || '') : '';
  var showUnit  = priceWrap ? priceWrap.getAttribute('data-show-unit') === 'true' : false;
  var showWeight= priceWrap ? priceWrap.getAttribute('data-show-weight') === 'true' : false;
  var weightEl  = document.getElementById('lbgs-weight-' + SID);
  var priceColor     = priceWrap ? (priceWrap.getAttribute('data-price-color') || '') : '';
  var salePriceColor = priceWrap ? (priceWrap.getAttribute('data-sale-price-color') || '') : '';
  var atcLabelEl  = atcBtn ? atcBtn.querySelector('.lbgs__atc-label') : null;
  var atcLabelTxt = atcBtn ? (atcBtn.getAttribute('data-label') || '') : '';
  var atcSoldTxt  = atcBtn ? (atcBtn.getAttribute('data-soldout-label') || 'Ausverkauft') : 'Ausverkauft';
  var atcNormalBg = atcBtn ? (atcBtn.getAttribute('data-normal-bg') || '') : '';
  var atcNormalFg = atcBtn ? (atcBtn.getAttribute('data-normal-color') || '') : '';
  var atcSoldBg   = atcBtn ? (atcBtn.getAttribute('data-soldout-bg') || '') : '';
  var atcSoldFg   = atcBtn ? (atcBtn.getAttribute('data-soldout-color') || '') : '';
  var delivEls    = wrap.querySelectorAll('.lbgs__delivery');


  var track  = sliderEl ? sliderEl.querySelector('.lbgs__track') : null;
  var slides = sliderEl ? sliderEl.querySelectorAll('.lbgs__slide') : [];
  var prevBtn= sliderEl ? sliderEl.querySelector('.lbgs__arr--prev') : null;
  var nextBtn= sliderEl ? sliderEl.querySelector('.lbgs__arr--next') : null;
  var thumbs = thumbsEl ? thumbsEl.querySelectorAll('.lbgs__thumb') : [];
  var dotsEl = document.getElementById('lbgs-dots-' + SID);
  var dots   = dotsEl ? dotsEl.querySelectorAll('.lbgs__dot') : [];


  var total = slides.length;
  var cur   = 0;
  var curVid= cfg.vid;


  /* ── Selected options (variant picker) ── */
  var selOpts = (function(){
    var init = vd.find(function(v){ return v.id === curVid; });
    return init ? init.opts.slice() : [];
  })();


  function findVariant(){
    return vd.find(function(v){
      return selOpts.every(function(val, i){ return val == null || v.opts[i] === val; });
    });
  }


  /* ── Gallery slider (kein Endlos-Scrollen) ── */
  function goTo(n){
    if(!track||!total) return;
    cur=Math.max(0,Math.min(n,total-1));
    if(track){ track.querySelectorAll('video').forEach(function(v){ try { v.pause(); } catch(e){} }); }
    track.style.transform='translateX(-'+(cur*100)+'%)';
    thumbs.forEach(function(t,i){t.classList.toggle('is-on',i===cur);});
    dots.forEach(function(d,i){d.classList.toggle('is-on',i===cur);});
    if(prevBtn) prevBtn.classList.toggle('is-disabled',cur===0);
    if(nextBtn) nextBtn.classList.toggle('is-disabled',cur===total-1);
    if(thumbsEl&&thumbs[cur]){
      var _t=thumbs[cur];
      var _left=_t.offsetLeft-(thumbsEl.clientWidth-_t.clientWidth)/2;
      thumbsEl.scrollTo({left:_left,behavior:'smooth'});
    }
  }
  if(prevBtn) prevBtn.addEventListener('click',function(){goTo(cur-1);});
  if(nextBtn) nextBtn.addEventListener('click',function(){goTo(cur+1);});
  thumbs.forEach(function(t,i){t.addEventListener('click',function(){goTo(i);});});
  dots.forEach(function(d,i){d.addEventListener('click',function(){goTo(i);});});
  goTo(0);


  if(sliderEl&&total>1){
    var tx0=0,ty0=0,sw=false,decided=false,horiz=false;
    sliderEl.addEventListener('touchstart',function(e){tx0=e.touches[0].clientX;ty0=e.touches[0].clientY;sw=false;decided=false;horiz=false;},{passive:true});
    sliderEl.addEventListener('touchmove',function(e){
      var dx=e.touches[0].clientX-tx0;
      var dy=e.touches[0].clientY-ty0;
      if(!decided && (Math.abs(dx)>6 || Math.abs(dy)>6)){ decided=true; horiz=Math.abs(dx)>Math.abs(dy); }
      if(decided && horiz){
        if(e.cancelable){ e.preventDefault(); } // Seite nicht mitscrollen lassen
        sw=true;
        if(track){ track.style.transition='none'; track.style.transform='translateX('+((-cur*100)+(dx/sliderEl.offsetWidth*100))+'%)'; }
      }
    },{passive:false});
    sliderEl.addEventListener('touchend',function(e){
      var dx=e.changedTouches[0].clientX-tx0;
      if(track)track.style.transition='';
      if(sw){dx<-40?goTo(cur+1):dx>40?goTo(cur-1):goTo(cur);}sw=false;
    },{passive:true});
  }


  /* ── Price update ── */
  function updatePrices(){
    var f=vd.find(function(v){return v.id===curVid;});
    var fmt=f?f.fmt:'–';
    if(priceEl) priceEl.textContent=fmt;
    if(vidInput) vidInput.value=String(curVid);


    var onSale = !!(f && f.cmp && f.cmp > f.cents);
    if(priceEl){
      var _c = onSale ? salePriceColor : priceColor;
      if(_c) priceEl.style.color = _c;
    }


    if(f&&cmpEl&&badgeEl){
      if(f.cmp&&f.cmp>f.cents){
        cmpEl.textContent=f.cmpFmt;
        cmpEl.style.display='';
        if(showBadge){
          var pct=Math.round((f.cmp-f.cents)*100/f.cmp);
          if(badgeType==='amount'){
            badgeEl.textContent = badgePrefix ? badgePrefix+' '+f.saveAmt : f.saveAmt+' sparen';
          } else {
            badgeEl.textContent = badgePrefix ? badgePrefix+' '+pct+'%' : '-'+pct+'%';
          }
          badgeEl.style.display='';
        } else {
          badgeEl.style.display='none';
        }
      } else {
        cmpEl.style.display='none';
        badgeEl.style.display='none';
      }
    }


    /* ── Gewicht der Variante ── */
    if(weightEl){
      if(showWeight && f && f.hasW){
        weightEl.textContent=f.wt;
        weightEl.style.display='';
      } else {
        weightEl.style.display='none';
      }
    }


    /* ── Grundpreis / Unit Price ── */
    if(unitEl){
      if(showUnit && f && f.hasUnit){
        unitEl.textContent = f.uFmt + '/' + (f.uRef != 1 ? f.uRef + ' ' : '') + (f.uUnit || '');
        unitEl.style.display='';
      } else {
        unitEl.style.display='none';
      }
    }


    /* ── Leere Gewicht/Grundpreis-Zeile + Abstand entfernen ── */
    var _wuVis = (showWeight && f && f.hasW) || (showUnit && f && f.hasUnit);
    var wuRow = document.getElementById('lbgs-wu-' + SID);
    if(wuRow){ wuRow.style.display = _wuVis ? '' : 'none'; }
    if(priceWrap && (weightEl || unitEl)){ priceWrap.style.gap = _wuVis ? '' : '0px'; }


    /* ── Preis-Hinweistext: Text tauschen bei Versand-Hürde ── */
    var _pnEls = wrap ? wrap.querySelectorAll('.lbgs__price-note[data-note-thr]') : [];
    for(var _pi=0; _pi<_pnEls.length; _pi++){
      var _pthr = parseInt(_pnEls[_pi].getAttribute('data-note-thr'),10) || 0;
      var _pnFs = _pnEls[_pi].getAttribute('data-note-fs') || '';
      var _pnDf = _pnEls[_pi].getAttribute('data-note') || '';
      var _pnTxt = (f && _pthr > 0 && f.cents >= _pthr && _pnFs) ? _pnFs : _pnDf;
      _pnEls[_pi].textContent = _pnTxt;
      _pnEls[_pi].style.display = _pnTxt ? '' : 'none';
    }


    /* ── Ausverkauft / CTA-Zustand ── */
    if(atcBtn){
      var _av = f ? f.avail : true;
      if(_av){
        atcBtn.classList.remove('is-soldout');
        atcBtn.disabled=false;
        if(atcLabelEl) atcLabelEl.textContent=atcLabelTxt;
        if(atcNormalBg) atcBtn.style.background=atcNormalBg;
        if(atcNormalFg) atcBtn.style.color=atcNormalFg;
      } else {
        atcBtn.classList.add('is-soldout');
        atcBtn.disabled=true;
        if(atcLabelEl) atcLabelEl.textContent=atcSoldTxt;
        if(atcSoldBg) atcBtn.style.background=atcSoldBg;
        if(atcSoldFg) atcBtn.style.color=atcSoldFg;
      }
    }


    /* ── Lieferzeiten: Ausverkauft-Zustand ── */
    if(delivEls && delivEls.length){
      var _avd = f ? f.avail : true;
      delivEls.forEach(function(d){
        var soText=d.getAttribute('data-soldout-text')||'';
        var txtEl=d.querySelector('.lbgs__delivery-text');
        if(!_avd && soText){
          if(txtEl) txtEl.textContent=soText;
          d.style.setProperty('background', d.getAttribute('data-soldout-bg')||'', 'important');
          d.style.setProperty('color', d.getAttribute('data-soldout-color')||'', 'important');
        } else {
          if(txtEl) txtEl.textContent=d.getAttribute('data-text')||'';
          d.style.setProperty('background', d.getAttribute('data-bg')||'', 'important');
          d.style.setProperty('color', d.getAttribute('data-color')||'', 'important');
        }
      });
    }
  }


  /* ── Variant picker — buttons ── */
  wrap.querySelectorAll('.lbgs__opt-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      if(this.classList.contains('is-off')) return;
      var optIdx=parseInt(this.getAttribute('data-opt'),10);
      var val=this.getAttribute('data-val');
      selOpts[optIdx]=val;


      wrap.querySelectorAll('.lbgs__opt-btn[data-opt="'+optIdx+'"]').forEach(function(b){
        b.classList.toggle('is-on', b.getAttribute('data-val')===val);
      });


      var valEl=document.getElementById('lbgs-ov-'+SID+'-'+optIdx);
      if(valEl) valEl.textContent=val;


      var matched=findVariant();
      if(matched){ curVid=matched.id; updatePrices(); if(matched.mi != null && matched.mi >= 0){ goTo(matched.mi); } }
    });
  });


  /* ── Variant picker — dropdown ── */
  wrap.querySelectorAll('.lbgs__opt-select').forEach(function(sel){
    sel.addEventListener('change',function(){
      var optIdx=parseInt(this.getAttribute('data-opt'),10);
      selOpts[optIdx]=this.value;
      var matched=findVariant();
      if(matched){ curVid=matched.id; updatePrices(); if(matched.mi != null && matched.mi >= 0){ goTo(matched.mi); } }
    });
  });


  /* ── Popup / Bottom-Sheet ── */
  function lbgsPopOpen(id){ var ov=document.getElementById('lbgs-pop-'+id); if(ov){ ov.classList.add('is-open'); document.body.style.overflow='hidden'; } }
  function lbgsPopClose(ov){ if(ov){ ov.classList.remove('is-open'); document.body.style.overflow=''; } }
  wrap.querySelectorAll('[data-pop-open]').forEach(function(b){
    b.addEventListener('click',function(){ lbgsPopOpen(this.getAttribute('data-pop-open')); });
  });
  wrap.querySelectorAll('[data-pop-close]').forEach(function(b){
    b.addEventListener('click',function(){ lbgsPopClose(document.getElementById('lbgs-pop-'+this.getAttribute('data-pop-close'))); });
  });
  wrap.querySelectorAll('.lbgs__pop-overlay').forEach(function(ov){
    ov.addEventListener('click',function(e){ if(e.target===ov) lbgsPopClose(ov); });
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ wrap.querySelectorAll('.lbgs__pop-overlay.is-open').forEach(lbgsPopClose); } });


  /* ── Quantity stepper ── */
  wrap.querySelectorAll('.lbgs__stepper').forEach(function(st){
    st.addEventListener('click',function(e){
      var btn=e.target.closest('.lbgs__step');
      if(!btn||!qtyInput) return;
      var v=Math.max(1,parseInt(qtyInput.value)||1);
      if(btn.classList.contains('lbgs__step--minus')) qtyInput.value=Math.max(1,v-1);
      else if(btn.classList.contains('lbgs__step--plus')) qtyInput.value=Math.min(99,v+1);
    });
  });
  if(qtyInput){
    qtyInput.addEventListener('change',function(){
      this.value=Math.max(1,Math.min(99,parseInt(this.value)||1));
    });
  }


  /* ── Gutschein-Code kopieren ── */
  function lbgsCopy(text){
    if(navigator.clipboard && navigator.clipboard.writeText){ return navigator.clipboard.writeText(text); }
    return new Promise(function(res,rej){
      try{ var ta=document.createElement('textarea'); ta.value=text; ta.style.position='fixed'; ta.style.opacity='0'; document.body.appendChild(ta); ta.focus(); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); res(); }catch(e){ rej(e); }
    });
  }
  wrap.querySelectorAll('.lbgs__cd-copy').forEach(function(btn){
    btn.addEventListener('click',function(){
      var code=btn.getAttribute('data-code')||'';
      lbgsCopy(code).then(function(){
        btn.classList.add('is-copied');
        setTimeout(function(){ btn.classList.remove('is-copied'); }, 1500);
      }).catch(function(){});
    });
  });


  /* ── Countdown ── */
  wrap.querySelectorAll('.lbgs__countdown').forEach(function(cd){
    var dl=new Date(cd.getAttribute('data-deadline')).getTime();
    if(isNaN(dl)) return;
    var dE=cd.querySelector('[data-d]'),hE=cd.querySelector('[data-h]'),mE=cd.querySelector('[data-m]'),sE=cd.querySelector('[data-s]');
    function pad(n){return (n<10?'0':'')+n;}
    function tick(){
      var diff=Math.max(0,dl-Date.now());
      var t=Math.floor(diff/1000);
      var d=Math.floor(t/86400);t-=d*86400;
      var h=Math.floor(t/3600);t-=h*3600;
      var m=Math.floor(t/60);t-=m*60;
      if(dE)dE.textContent=pad(d);if(hE)hE.textContent=pad(h);if(mE)mE.textContent=pad(m);if(sE)sE.textContent=pad(t);
    }
    tick();setInterval(tick,1000);
  });


  /* ── Sprachnotiz ── */
  wrap.querySelectorAll('.lbgs__voice').forEach(function(v){
    var audio=v.querySelector('audio'),btn=v.querySelector('.lbgs__voice-btn'),
        play=v.querySelector('.lbgs__voice-play'),pause=v.querySelector('.lbgs__voice-pause'),
        curEl=v.querySelector('.lbgs__voice-cur'),durEl=v.querySelector('.lbgs__voice-dur'),
        bars=v.querySelectorAll('.lbgs__voice-wave span');
    if(!audio||!btn) return;
    function fmt(t){t=Math.floor(t||0);if(!isFinite(t)||t<0)t=0;var m=Math.floor(t/60),s=t%60;return m+':'+(s<10?'0':'')+s;}
    function setDur(){ if(durEl&&isFinite(audio.duration))durEl.textContent=fmt(audio.duration); }
    btn.addEventListener('click',function(){ if(audio.paused){audio.play();}else{audio.pause();} });
    audio.addEventListener('play',function(){ if(play)play.style.display='none'; if(pause)pause.style.display='block'; });
    audio.addEventListener('pause',function(){ if(play)play.style.display='block'; if(pause)pause.style.display='none'; });
    audio.addEventListener('loadedmetadata',setDur);
    audio.addEventListener('durationchange',setDur);
    if(audio.readyState>0)setDur();
    audio.addEventListener('timeupdate',function(){
      var dur=audio.duration||1,n=Math.floor((audio.currentTime/dur)*bars.length);
      if(curEl)curEl.textContent=fmt(audio.currentTime);
      bars.forEach(function(b,i){ b.classList.toggle('on', i<n); });
    });
    audio.addEventListener('ended',function(){ bars.forEach(function(b){b.classList.remove('on');}); if(curEl)curEl.textContent=fmt(0); });
    bars.forEach(function(b,i){ b.addEventListener('click',function(){ if(audio.duration){audio.currentTime=(i/bars.length)*audio.duration;} }); });
  });


  /* ── Produktvideo-Bubble: in die Galerie verschieben (oben in der Ecke des Bildes) ── */
  var galleryEl = wrap.querySelector('.lbgs__gallery');
  if(galleryEl){
    wrap.querySelectorAll('.lbgs__vbubble').forEach(function(b){ galleryEl.appendChild(b); });
  }


  /* ── Produktvideo-Bubble (Lightbox) ── */
  wrap.querySelectorAll('.lbgs__vbubble-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var bubble=btn.closest('.lbgs__vbubble');
      var url=bubble?bubble.getAttribute('data-video'):'';
      if(!url){ return; }
      var ov=document.createElement('div');
      ov.className='lbgs__vmodal';
      var inner=document.createElement('div');
      inner.className='lbgs__vmodal-inner';
      var close=document.createElement('button');
      close.className='lbgs__vmodal-close';
      close.setAttribute('aria-label','Schließen');
      close.textContent='×';
      var vid=document.createElement('video');
      vid.src=url; vid.controls=true; vid.autoplay=true; vid.playsInline=true; vid.setAttribute('playsinline','');
      inner.appendChild(close); inner.appendChild(vid); ov.appendChild(inner);
      document.body.appendChild(ov);
      function shut(){ try{vid.pause();}catch(e){} if(ov.parentNode){ov.parentNode.removeChild(ov);} document.removeEventListener('keydown',onKey); }
      function onKey(e){ if(e.key==='Escape'){ shut(); } }
      ov.addEventListener('click',function(e){ if(e.target===ov||e.target===close){ shut(); } });
      document.addEventListener('keydown',onKey);
    });
  });


  /* ── Produktverlinkung Dropdown (eigenes Design) ── */
  wrap.querySelectorAll('[data-pdrop]').forEach(function(dp){
    var t=dp.querySelector('[data-pdrop-toggle]');
    if(t){ t.addEventListener('click',function(e){ e.stopPropagation(); var open=dp.classList.toggle('is-open'); t.setAttribute('aria-expanded',open?'true':'false'); }); }
  });
  document.addEventListener('click',function(e){ wrap.querySelectorAll('[data-pdrop].is-open').forEach(function(dp){ if(!dp.contains(e.target)){ dp.classList.remove('is-open'); var tt=dp.querySelector('[data-pdrop-toggle]'); if(tt) tt.setAttribute('aria-expanded','false'); } }); });


  /* ── Video-Grid (Lightbox) ── */
  wrap.querySelectorAll('.lbgs__vgrid-item').forEach(function(btn){
    btn.addEventListener('click',function(){
      var url=btn.getAttribute('data-video')||'';
      if(!url){ return; }
      var ov=document.createElement('div');
      ov.className='lbgs__vmodal';
      var inner=document.createElement('div');
      inner.className='lbgs__vmodal-inner';
      var close=document.createElement('button');
      close.className='lbgs__vmodal-close';
      close.setAttribute('aria-label','Schließen');
      close.textContent='×';
      var vid=document.createElement('video');
      vid.src=url; vid.controls=true; vid.autoplay=true; vid.playsInline=true; vid.setAttribute('playsinline','');
      inner.appendChild(close); inner.appendChild(vid); ov.appendChild(inner);
      document.body.appendChild(ov);
      function shut(){ try{vid.pause();}catch(e){} if(ov.parentNode){ov.parentNode.removeChild(ov);} document.removeEventListener('keydown',onKey); }
      function onKey(e){ if(e.key==='Escape'){ shut(); } }
      ov.addEventListener('click',function(e){ if(e.target===ov||e.target===close){ shut(); } });
      document.addEventListener('keydown',onKey);
    });
  });


  /* ── Testimonial-Slider (Autoplay + Swipe) ── */
  wrap.querySelectorAll('[data-testi]').forEach(function(el){
    var track=el.querySelector('.lbgs__testi-track');
    if(!track) return;
    var slides=track.children;
    var n=slides.length;
    var idx=0, timer=null;
    var interval=parseInt(el.getAttribute('data-autoplay'),10)||0;
    var dotsWrap=el.querySelector('.lbgs__testi-dots');
    var dots=[];
    if(dotsWrap && n>1){
      for(var i=0;i<n;i++){ var d=document.createElement('button'); d.type='button'; d.className='lbgs__testi-dot'; d.setAttribute('aria-label','Stimme '+(i+1)); (function(k){ d.addEventListener('click',function(){ go(k); restart(); }); })(i); dotsWrap.appendChild(d); dots.push(d); }
    }
    function render(){ track.style.transform='translateX('+(-idx*100)+'%)'; for(var i=0;i<dots.length;i++){ dots[i].classList.toggle('is-on', i===idx); } }
    function go(i){ idx=((i%n)+n)%n; render(); }
    function start(){ if(interval>0 && n>1){ timer=setInterval(function(){ go(idx+1); }, interval*1000); } }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    function restart(){ stop(); start(); }
    if(n>1){
      var sx=0, dx=0, drag=false;
      track.addEventListener('touchstart',function(e){ sx=e.touches[0].clientX; dx=0; drag=true; stop(); track.style.transition='none'; },{passive:true});
      track.addEventListener('touchmove',function(e){ if(!drag) return; dx=e.touches[0].clientX-sx; track.style.transform='translateX(calc('+(-idx*100)+'% + '+dx+'px))'; },{passive:true});
      track.addEventListener('touchend',function(){ if(!drag) return; drag=false; track.style.transition=''; if(Math.abs(dx)>40){ go(idx+(dx<0?1:-1)); } else { render(); } restart(); });
    }
    render(); start();
  });


  /* ── Add to cart (AJAX → Cart-Drawer) ── */
  var addForm = document.getElementById('lbgs-form-' + SID);
  var lbgsFast = !!cfg.fast;
  function lbgsAddToCart(){
    if(!addForm) return;
    var cartDrawer = document.querySelector('cart-drawer');
    var cartNotif  = document.querySelector('cart-notification');
    var cartEl = cartDrawer || cartNotif;
    var fd = new FormData(addForm);
    var ids = [];
    if(cartEl && typeof cartEl.getSectionsToRender === 'function'){
      try { ids = cartEl.getSectionsToRender().map(function(s){ return s.id; }); } catch(e){}
    }
    // Shoptimized & Co.: eigenen Cart-Drawer ("cart-summary") als Section mitrendern lassen
    var lbgsCsEl   = document.getElementById('cart-summary');
    var lbgsCsWrap = lbgsCsEl ? lbgsCsEl.closest('[id^="shopify-section-"]') : null;
    var lbgsCsSect = lbgsCsWrap ? lbgsCsWrap.id.replace('shopify-section-','') : null;
    if(lbgsCsSect && !lbgsFast && ids.indexOf(lbgsCsSect) === -1){ ids.push(lbgsCsSect); }
    if(ids.length){ fd.append('sections', ids.join(',')); fd.append('sections_url', window.location.pathname); }
    if(atcBtn){ atcBtn.setAttribute('aria-busy','true'); atcBtn.classList.add('is-loading'); atcBtn.disabled = true; }
    function done(){ if(atcBtn){ atcBtn.removeAttribute('aria-busy'); atcBtn.classList.remove('is-loading'); atcBtn.disabled = false; } }
    function lbgsRefreshCount(){
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var n = cart.item_count;
          document.querySelectorAll('.cart-count-bubble').forEach(function(b){
            var s = b.querySelector('span[aria-hidden]') || b.querySelector('span');
            if(s){ s.textContent = n; }
          });
          document.querySelectorAll('[data-cart-count],.cart-count,cart-count,#CartCount,.cart-link__bubble-num,.cart-link__count,.header__cart-count,.site-header__cart-count,[data-cart-item-count],.cart-item-count,.js-cart-count,.current-cart-count,.inner-count').forEach(function(el){
            el.textContent = n;
            if(el.hasAttribute('data-cart-count')){ el.setAttribute('data-cart-count', n); }
            if(el.hasAttribute('data-cart-item-count')){ el.setAttribute('data-cart-item-count', n); }
          });
        }).catch(function(){});
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
    .then(function(r){ return r.json(); })
    .then(function(state){
      if(state && state.status){ done(); return; }
      lbgsRefreshCount();
      var handled = false;
      // 0) Shoptimized & Co.: eigener "cart-summary"-Drawer.
      //    Inhalt deterministisch via Section-Rendering einsetzen, dann öffnen (Fallback: refresh_shop_cart).
      if(!handled && lbgsCsWrap){
        function lbgsOpenCs(){
          if(!document.body.classList.contains('show-cart-summary')){
            var togs0 = document.querySelectorAll('.toggle-cart-summary, .current-cart');
            for(var ti0=0; ti0<togs0.length; ti0++){
              var el0 = togs0[ti0];
              if(el0.offsetParent !== null && !el0.closest('#cart-summary')){ try { el0.click(); } catch(e){} break; }
            }
          }
        }
        if(lbgsFast){
          // Schnell: kein Section-Rendering im Add-Request. Theme-eigene Aktualisierung anstoßen und Drawer sofort öffnen.
          if(typeof window.refresh_shop_cart === 'function'){ try { window.refresh_shop_cart(); } catch(e){} }
          lbgsOpenCs();
          done();
        } else {
          var lbgsFilled = false;
          if(lbgsCsSect && state.sections && state.sections[lbgsCsSect]){
            try { lbgsCsWrap.outerHTML = state.sections[lbgsCsSect]; lbgsFilled = true; } catch(e){}
          }
          if(!lbgsFilled && typeof window.refresh_shop_cart === 'function'){
            try { window.refresh_shop_cart(); } catch(e){}
          }
          var lbgsTries = 0;
          var lbgsIv = setInterval(function(){
            lbgsTries++;
            var cs = document.getElementById('cart-summary');
            var ready = cs && cs.className.indexOf('cart-summary--empty') < 0 && cs.innerText.trim().length > 0;
            if(ready || lbgsTries > 25){ clearInterval(lbgsIv); lbgsOpenCs(); }
          }, 150);
        }
        handled = true;
      }
      // 1) Dawn-Familie: cart-drawer / cart-notification (frisch rendern + oeffnen)
      if(cartEl && typeof cartEl.renderContents === 'function'){
        try {
          cartEl.renderContents(state);
          if(cartDrawer){
            cartDrawer.classList.remove('is-empty');
            var ce = cartDrawer.querySelector('cart-drawer-items');
            if(ce){ ce.classList.remove('is-empty'); }
            if(typeof cartDrawer.open === 'function'){ cartDrawer.open(); }
          }
          handled = true;
        } catch(e){}
      }
      // 2) Maestrooo (Prestige/Impact/Stretch) & generische Themes: Inhalt aktualisieren
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch(e){}
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: state } })); } catch(e){}
      try { document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true })); } catch(e){}
      // 3) Drawer-Element mit show()-Methode (Prestige v7+, diverse Custom Elements)
      if(!handled){
        var drawerEl = document.querySelector('#mini-cart,[id*="mini-cart"],#cart-drawer,.cart-drawer,cart-drawer,[data-cart-drawer]');
        if(drawerEl && typeof drawerEl.show === 'function'){ try { drawerEl.show(); handled = true; } catch(e){} }
      }
      // 4) Universell: themeeigenes Warenkorb-Symbol/Toggle anklicken -> oeffnet den jeweiligen Drawer
      if(!handled){
        var togSel = ['[aria-controls*="cart"]','[data-cart-drawer-toggle]','[data-action="open-drawer"]','[data-action="open-cart"]','[data-drawer="cart"]','[data-drawer-toggle*="cart"]','.js-drawer-open-cart'];
        for(var ti=0; ti<togSel.length && !handled; ti++){
          var tog = document.querySelector(togSel[ti]);
          if(tog && typeof tog.click === 'function'){ try { tog.click(); handled = true; } catch(e){} }
        }
      }
      done();
      // 5) Kein Drawer gefunden: auf der Seite bleiben (Counter wurde bereits aktualisiert)
    })
    .catch(function(){ done(); });
  }
  if(addForm){
    addForm.addEventListener('submit', function(e){ e.preventDefault(); lbgsAddToCart(); });
  }


  updatePrices();


}

  function lbgsBoot(scope){
    var list = (scope || document).querySelectorAll('script[data-lbgs-config]');
    for(var i=0;i<list.length;i++){
      var el = list[i];
      if(el.getAttribute('data-lbgs-done')) continue;
      el.setAttribute('data-lbgs-done','1');
      var cfg = null;
      try { cfg = JSON.parse(el.textContent); } catch(e){ cfg = null; }
      if(!cfg || cfg.sid == null) continue;
      try { lbgsInit(cfg); } catch(e){ if(window.console && console.error){ console.error('lb-theone-buybox', e); } }
    }
  }
  lbgsBoot(document);
  document.addEventListener('shopify:section:load', function(e){ lbgsBoot(e.target || document); });
})();